module.exports = __webpack_public_path__ + "static/media/img1.52c78ddb.jpg";